import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { HighlightOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { actionGetClientTheme } from "../../../actions/AppSettings.action";
import { getClientDomain } from "../../../libs/domain.utils";

import "./ResetPasswordExpiredView.css";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";

function ResetPasswordExpiredView() {
  const dispatch = useDispatch();
  const appSettings = useSelector((state) => state.app_setting);
  const clientTheme = appSettings?.client_theme;

  useEffect(() => {
    const domain = getClientDomain();
    if (domain && !clientTheme) {
      dispatch(actionGetClientTheme(domain));
    }
  }, [dispatch, clientTheme]);

  useEffect(() => {
    if (clientTheme?.fav_icon) {
      const link = document.querySelector("link[rel='shortcut icon']");
      if (link) {
        link.href = clientTheme.fav_icon;
      }
    }
  }, [clientTheme]);

  return (
    <div
      className="resetExpiredPage"
      style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
    >
      <div
        className="resetExpiredOverlay"
        style={clientTheme?.background_image ? { backgroundImage: `url(${clientTheme.background_image})` } : {}}
      ></div>

      <div className="resetExpiredContainer">
        <div className="resetExpiredCard">
          <div className="resetExpiredLogoWrapper">
            <img
              src={
                clientTheme?.display_logo ||
                require("../../../assets/CRMAssets/psconnect_login_logo@2x.png")
              }
              alt="PS Connect"
              className="resetExpiredLogo"
              style={{
                maxHeight: "80px",
                maxWidth: "220px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          <div className="resetExpiredIconWrapper">
            <div className="resetExpiredErrorCircle">
              <HighlightOff
                style={{
                  color: "#ff6464",
                  fontSize: 48,
                }}
              />
            </div>
          </div>

          <Typography className="resetExpiredTitle">
            Link Expired or Invalid
          </Typography>

          <Typography className="resetExpiredDescription">
            The password reset link has expired or is no longer valid.
            <br />
            Reset links are only active for 1 hour.
          </Typography>

          <div className="resetExpiredButtonWrapper">
            <PrimaryButton
              className="resetExpiredButton"
              onClick={() => (window.location.href = "/forgot-password")}
            >
              REQUEST NEW LINK →
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordExpiredView;